const VacancyArchiveView = Barba.BaseView.extend({
    namespace: 'vacancy-archive',

    onEnter: function() {
        new MainMenu(this.container);
        new InViewAnimation();
        new SearchModal(this.container);
   
        setIframeAspectRatios(this.container);

        setTimeout(_ => { setScrollAnchorPosition(this.container); }, 500)
        window.addEventListener('hashchange', _ => { setScrollAnchorPosition(this.container); });
    }
});

VacancyArchiveView.init();